// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_iv-0";
export var optionCard = "_iv-1";